import { SettingsForm, SettingsFormProps } from './SettingsForm';
import { useVpaSelectedSettingName } from '../../vpaSelectedSettingNameContexts';

type Props = Omit<SettingsFormProps, 'isDefault'>;

export const VerticalSettingsForm = ({ ...props }: Props) => {
  const { useSettingIsDefault, settingName } = useVpaSelectedSettingName();

  const isDefault = useSettingIsDefault(settingName);

  return <SettingsForm {...props} isDefault={!!isDefault} />;
};
